import React from 'react';
import { logout, useDialog } from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper
} from '@mui/material';
import { TranslatedText, useRouterPush } from '@ianesthesie-kit/core';
import { useAppDispatch } from '@/hooks';

const toKey = (tail: string) => `app.error.tokenExpired.${tail}`;

export const TokenExpiredDialog = () => {
  const { closeDialog } = useDialog();
  const dispatch = useAppDispatch();
  const push = useRouterPush();
  const closeAndRedirect = () => {
    dispatch(logout());
    push('/auth/login');
    closeDialog();
  };

  return (
    <Paper sx={{ p: 0, maxWidth: 380 }}>
      <DialogTitle>
        <TranslatedText id={toKey('title')} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <TranslatedText id={toKey('body')} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAndRedirect}>
          <TranslatedText id={toKey('button')} />
        </Button>
      </DialogActions>
    </Paper>
  );
};
